import { createContext } from 'react'

const clinicalCareContext = createContext()

export default clinicalCareContext
